import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

const AttachmentPreviewModal = ({ open, file, onClose }) => {
  if (!file) return null;

  const filePath = file.path || file.cloud_path || "";

  const isImage =
    file.type?.startsWith("image/") ||
    /\.(jpg|jpeg|png|gif|webp)$/i.test(filePath);

  const isPdf = file.type === "application/pdf" || /\.pdf$/i.test(filePath);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {file.title || file.file_title || "Attachment"}

        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {isImage && (
          <Box
            component="img"
            src={filePath}
            alt={file.title || "Attachment"}
            sx={{
              width: "100%",
              maxHeight: "70vh",
              objectFit: "contain",
            }}
          />
        )}

        {isPdf && (
          <Box
            component="iframe"
            src={filePath}
            title="PDF Preview"
            sx={{
              width: "100%",
              height: "70vh",
              border: 0,
            }}
          />
        )}

        {!isImage && !isPdf && (
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ py: 5, textAlign: "center" }}
          >
            Preview is not available for this file type.
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AttachmentPreviewModal;
